import cmp from './ThemeButton'

export default cmp
